module.exports = __webpack_public_path__ + "static/media/logo-fetch-blue-knockout-sm.027cd3db.svg";